import { ISelectOption } from '../../ui-toolkit';

export enum eCheckVoidReason {
  Stale = 'Stale',
  StaleAutoVoided = 'StaleAutoVoided',
  WrongPayee = 'WrongPayee',
  WrongAddress = 'WrongAddress',
  IncorrectAmount = 'IncorrectAmount',
  Returned = 'Returned',
  Misplaced = 'Misplaced',
  ReissuingAsOtherPaymentMethod = 'ReissuingAsOtherPaymentMethod',
  LostInMail = 'LostInMail',
  Other = 'Other',
}

export const prettyCheckVoidReason: Record<eCheckVoidReason, string> = {
  Stale: 'Stale check',
  StaleAutoVoided: 'Auto-void, 90 days elapsed without completion',
  WrongPayee: 'Wrong payee',
  WrongAddress: 'Wrong address',
  IncorrectAmount: 'Incorrect amount',
  Returned: 'Check returned',
  Misplaced: 'Recipient misplaced',
  ReissuingAsOtherPaymentMethod: 'Reissuing as wire/other payment method',
  LostInMail: 'Lost in mail',
  Other: 'Other',
};

export const checkVoidReasonOptions: ISelectOption<eCheckVoidReason>[] = Object.entries(eCheckVoidReason)
  .filter(([_, value]) => value !== eCheckVoidReason.StaleAutoVoided)
  .map(([_, value]) => ({ label: prettyCheckVoidReason[value], value: value }));
